import Export from '@pages/Export.vue';
import ExportOld from '@pages/ExportOld.vue';

export default [
  {
    path: '/export',
    name: 'Export',
    component: Export,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
  {
    path: '/export-old',
    name: 'ExportOld',
    component: ExportOld,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
];
